<nh-alert type="warning" [isOpen]="uploadDocumentFlag">
  <div class="d-flex align-items-center">
    <div class="me-2">
      <img
        src="../../../../../../assets/images/Icons/⚛️ icons-warning-outline.svg"
        alt=""
        aria-hidden="true"
      />
    </div>
    <div>
      <span [innerHTML]="'UPLOAD_APPEAL_BANNER' | globalTranslate"></span>
    </div>
  </div>
</nh-alert>
<div class="p-1 mt-1 d-none d-lg-block">
  @if (!ridpFlow) {
  <div>
    <h1 class="section-header">{{ "UPLOAD_DOCUMENT1" | globalTranslate }}</h1>
    <hr />
    @if (!isMobileView && !uploadDocumentFlag) {
    <ngx-datatable
      class="bootstrap striped"
      limit="5"
      #table
      [rows]="rows"
      [columnMode]="'force'"
      [headerHeight]="'auto'"
      [footerHeight]="50"
      [rowHeight]="'auto'"
    >
      @for (col of columns; track col) {
      <ngx-datatable-column
        [name]="col.name | globalTranslate"
        [prop]="col.prop"
      >
        <ng-template
          ngx-datatable-cell-template
          let-row="row"
          let-value="value"
          let-rowIndex="rowIndex"
        >
          <span>{{ value === "N/A" ? value : (value | globalTranslate) }}</span>
        </ng-template>
      </ngx-datatable-column>
      }
    </ngx-datatable>
    } @if (uploadDocumentFlag) {
    <ngx-datatable
      class="bootstrap striped"
      limit="5"
      #table
      [rows]="rowsData"
      [columnMode]="'force'"
      [headerHeight]="'auto'"
      [footerHeight]="50"
      [rowHeight]="'auto'"
    >
      <ngx-datatable-column [name]="'Name' | globalTranslate" prop="fullName">
        <ng-template ngx-datatable-cell-template let-value="value">
          <span>{{ value }}</span>
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column
        [name]="'Proof Type' | globalTranslate"
        prop="verfDesc"
      >
        <ng-template ngx-datatable-cell-template let-value="value">
          <span>{{ value | globalTranslate }}</span>
        </ng-template>
      </ngx-datatable-column>
    </ngx-datatable>
    } @if (isMobileView && !row?.refId && uploadDocumentFlag &&
    !isMedicalAppeal) {
    <div>
      @if (rowsData.length) { @for (row of rowsData; track row) {
      <div>
        <p>
          <strong>{{ columnData[0].name | globalTranslate }}</strong>
        </p>
        aaa
        <hr />
        <p>{{ row?.fullName }}</p>
        <br />
        <p>
          <strong>{{ columnData[1].name | globalTranslate }}</strong>
        </p>
        <hr />
        @if (translatedLang === 'en') {
        <p>{{ row?.verfDesc | globalTranslate }}</p>
        }
      </div>
      } } @if (!rows.length) {
      <p class="mb-5">{{ "NO_DATA_TO_DISPLAY" | globalTranslate }}</p>
      }
    </div>
    } @if (isMobileView && !row?.refId && !uploadDocumentFlag &&
    !isMedicalAppeal) {
    <div>
      @if (rows.length) { @for (row of rows; track row) {
      <div>
        <p>
          <strong>{{ columns[0].name | globalTranslate }}</strong>
        </p>
        <hr />
        <p>{{ row?.fullName }}</p>
        <br />
        <p>
          <strong>{{ columns[1].name | globalTranslate }}</strong>
        </p>
        <hr />
        @if (translatedLang === 'en') {
        <p>{{ row?.proofType | globalTranslate }}</p>
        } @if (translatedLang !== 'en') {
        <p>{{ row?.proofTypeEs }}</p>
        }
        <br />
        <p>
          <strong>{{ columns[2].name | globalTranslate }}</strong>
        </p>
        <hr />
        <p>{{ row?.proofRequiredValue | globalTranslate }}</p>
        <br />
        @if (!(row?.verfDesc === 'Documents for Appeals' || row?.verfDesc ===
        'Documentos para Apelaciones' || row?.verfDesc === 'Appeal Facts
        Documents' || row?.verfDesc === 'Documento de información para la
        apelación')) {
        <div>
          <p>
            <strong>{{ columns[3].name | globalTranslate }}</strong>
          </p>
          <hr />
          <p>{{ row?.verfDue }}</p>
          <br />
        </div>
        }
      </div>
      } } @if (!rows.length) {
      <p class="mb-5">{{ "NO_DATA_TO_DISPLAY" | globalTranslate }}</p>
      }
    </div>
    } @if (isMobileView && !row?.refId && isMedicalAppeal) {
    <div>
      @if (rows.length) { @for (row of rows; track row) {
      <div>
        <p>
          <strong>{{ columns[0].name | globalTranslate }}</strong>
        </p>
        <hr />
        <p>{{ row?.fullName }}</p>
        <br />
        <p>
          <strong>{{ columns[1].name | globalTranslate }}</strong>
        </p>
        <hr />
        @if (isMedicalAppeal) {
        <p>{{ row?.verfDesc | globalTranslate }}</p>
        }
        <br />
        @if ((row.verfDesc === 'Additional Information Form' || row.verfDesc ===
        'Formulario para Información Adicional')) {
        <div>
          <p>
            <strong>{{ columns[2].name | globalTranslate }}</strong>
          </p>
          <hr />
          <p>{{ row?.appealDueDate }}</p>
          <br />
        </div>
        }
      </div>
      } } @if (!rows.length) {
      <p class="mb-5">{{ "NO_DATA_TO_DISPLAY" | globalTranslate }}</p>
      }
    </div>
    } @if (translatedLang === 'en' && !uploadDocumentFlag && !isMedicalAppeal &&
    !isKatieDocUpload && !verificationForFlag) {
    <h2 class="section-header">
      {{ row?.fullName }}'s {{this.rows[0]?.['proofType'] | globalTranslate}}
    </h2>
    } @if (translatedLang !== 'en' && !uploadDocumentFlag && !isMedicalAppeal &&
    !isKatieDocUpload && !verificationForFlag) {
    <h2 class="section-header">
      {{ row?.fullName }}'s {{this.rows[0]?.['proofTypeEs']}}
    </h2>
    } @if (translatedLang === 'en' && !uploadDocumentFlag && !isMedicalAppeal &&
    !isKatieDocUpload && verificationForFlag) {
    <h2 class="section-header">
      {{ row?.fullName }}'s {{this.rows[0]?.['proofType'] | globalTranslate}} -
      {{this.rows[0]?.['proofRequiredValue'] | globalTranslate}}
    </h2>
    } @if (translatedLang !== 'en' && !uploadDocumentFlag && !isMedicalAppeal &&
    !isKatieDocUpload && verificationForFlag) {
    <h2 class="section-header">
      {{ row?.fullName }}'s {{this.rows[0]?.['proofTypeEs']}} -
      {{this.rows[0]?.['proofRequiredValue'] | globalTranslate}}
    </h2>
    } @if (translatedLang === 'en' && !uploadDocumentFlag && !isMedicalAppeal &&
    isKatieDocUpload) {
    <h2 class="section-header">
      {{ row?.fullName }}'s {{ this.vfdProofType | globalTranslate }}
    </h2>
    } @if (translatedLang !== 'en' && !uploadDocumentFlag && !isMedicalAppeal &&
    isKatieDocUpload) {
    <h2 class="section-header">
      {{ row?.fullName }}'s {{ this.vfdProofType }}
    </h2>
    } @if (translatedLang === 'en' && uploadDocumentFlag && !isMedicalAppeal) {
    <h2 class="section-header">
      {{ row?.fullName }}'s {{ this.vfdProofType | globalTranslate }}
    </h2>
    } @if (translatedLang !== 'en' && uploadDocumentFlag && !isMedicalAppeal) {
    <h2 class="section-header">
      {{ row?.fullName }}'s {{ this.vfdProofType }}
    </h2>
    } @if (translatedLang === 'en' && isMedicalAppeal) {
    <h2 class="section-header">
      {{ row?.fullName }}'s {{ this.vfdProofType | globalTranslate }}
    </h2>
    } @if (translatedLang !== 'en' && isMedicalAppeal) {
    <h2 class="section-header">{{ this.vfdProofType }} {{ row?.fullName }}</h2>
    }
    <hr />
    @if (error && !isMedicalAppeal) {
    <p
      class="static-text"
      [innerHtml]="'DOC_BEFORE_UPLOAD_TEXT' | globalTranslate"
    ></p>
    } @if (!error) {
    <p
      class="static-text"
      [innerHtml]="'DOC_AFTER_UPLOAD_TEXT' | globalTranslate"
    ></p>
    } @if (error && isMedicalAppeal) {
    <p
      class="static-text"
      [innerHtml]="'DOC_BEFORE_UPLOAD_TEXT_MEDAPP' | globalTranslate"
    ></p>
    }
  </div>
  } @if (ridpFlow) {
  <div>
    <h2 class="section-header">
      {{ "RIDP_UPLOADDOC_STATIC1" | globalTranslate }}
    </h2>
    <hr />
    <p [innerHTML]="'RIDP_UPLOADDOC_STATIC2' | globalTranslate"></p>
    <!-- <p class="nh-table-mobile d-lg-none" [innerHTML]="'RIDP_UPLOADDOC_STATIC2_Mobile' | globalTranslate"></p> -->
    <div class="pb-3 popup">
      <a
        title="{{ 'RIDP_UPLOADDOC_STATIC3' | globalTranslate }}"
        role="link"
        tabindex="0"
        (click)="showDocTypes()"
        (keydown.enter)="showDocTypes(); $event.preventDefault()"
        (keydown.space)="showDocTypes(); $event.preventDefault()"
      >
        <span class="pe-2">{{
          "RIDP_UPLOADDOC_STATIC3" | globalTranslate
        }}</span>
        <span><i class="fa fa-external-link" aria-hidden="true"></i></span>
      </a>
    </div>
  </div>
  } @for (doc of documents; track doc; let i = $index) {
  <div>
    <div class="row">
      @if ((ridpFlow && i=== 0) || !ridpFlow) {
      <div class="col-md-12">
        <span class="text-danger" aria-hidden="true">*</span
        ><label for="docType" class="label-section">{{
          (ridpFlow ? "ID_VERIFY_DOC_TYPE" : "DOCUMENT_TYPE") | globalTranslate
        }}</label>
        @if (!isMedicalAppeal && !ridpFlow) {
        <p
          class="static-text"
          [innerHtml]="'DOCUMENT_TEXT' | globalTranslate"
        ></p>
        } @if (isMobileView && !doc.file && i !== 0) {
        <a
          role="button"
          tabindex="0"
          (click)="close(i)"
          (keydown.enter)="close(i); $event.preventDefault()"
          (keydown.space)="close(i); $event.preventDefault()"
          class="mobile-upload-btn-close"
          ><span class="pe-2">{{ "CLOSE" | globalTranslate }}</span
          ><i class="fa fa-times-circle" aria-hidden="true"></i
        ></a>
        }
        <div class="mt-3">
          @if (translatedLang === 'en') {
          <select
            class="custom-select-info"
            aria-label="documentType"
            [(ngModel)]="doc.docType"
            name="doc.docType"
            (change)="selectedOption(i)"
            required
          >
            <option [ngValue]="null">
              {{ "PICK_AN_OPTION" | globalTranslate }}
            </option>
            @for (option of options; track option) {
            <option [ngValue]="option">
              {{ option.enDescription | globalTranslate }}
            </option>
            }
          </select>
          } @if (translatedLang !== 'en') {
          <select
            class="custom-select-info"
            aria-label="tipo de documento"
            [(ngModel)]="doc.docType"
            name="doc.docType"
            (change)="selectedOption(i)"
            required
          >
            <option [ngValue]="null">Elija una opción</option>
            @for (option of options; track option) {
            <option [ngValue]="option">{{ option.spDescription }}</option>
            }
          </select>
          }
        </div>
        @if (doc.error) {
        <div class="error-messages position-relative">
          <span class="form-text invalid-tooltip d-block">
            <ng-container>{{ "REQUIRED" | globalTranslate }}</ng-container>
          </span>
        </div>
        }
      </div>
      } @if (!isMobileView && !doc.file && i !== 0) {
      <div class="col-md-2 offset-md-4">
        <div class="ps-1 pt-1 hover-red upload-btn-close">
          <a
            role="button"
            tabindex="0"
            (click)="close(i)"
            (keydown.enter)="close(i); $event.preventDefault()"
            (keydown.space)="close(i); $event.preventDefault()"
            ><span class="pe-2">{{ "CLOSE" | globalTranslate }}</span
            ><i class="fa fa-times-circle" aria-hidden="true"></i
          ></a>
        </div>
      </div>
      }
    </div>
    @if (doc.show) {
    <div class="row pt-2">
      <div class="col-md-12">
        <nh-file-upload
          (passFileData)="getFileDetails($event, i)"
          (fileUploadStarted)="getFileProgress($event)"
        >
        </nh-file-upload>
      </div>
    </div>
    } @if (doc.file) {
    <div
      class="uploaded-documentname p-2 mt-2 d-flex align-items-center flex-wrap"
    >
      <div class="pe-2 flex-shrink-0">
        <img
          alt=""
          aria-hidden="true"
          role="presentation"
          src="../../../../../../assets/images/⚛️ icons-document-attach-outline.svg"
        />
      </div>
      <div class="me-3 text-truncate min-w-0" style="max-width: 440px">
        <span>{{ doc.file.name }}</span>
      </div>
      <div
        class="hover-red option-lables ms-3 d-inline-flex align-items-center gap-3"
      >
        <a
          class="btn btn-link hover-red d-inline-flex align-items-center text-nowrap p-0"
          tabindex="0"
          (click)="viewPdf(i, 'desktopBrowser')"
        >
          <span class="pe-2">{{ "View" | globalTranslate }}</span>
          <svg
            id="_icons_search-outline"
            data-name="⚛️ icons/search-outline"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            width="24"
            height="24"
            viewBox="0 0 24 24"
          >
            <defs>
              <clipPath id="clip-path">
                <rect id="Background" width="24" height="24" fill="#174a7c" />
              </clipPath>
            </defs>
            <g
              id="Mask_Group_1"
              data-name="Mask Group 1"
              clip-path="url(#clip-path)"
            >
              <path
                id="Combined_Shape"
                data-name="Combined Shape"
                d="M18.232,19.292l-.013-.012-4.927-4.927a8.122,8.122,0,1,1,1.061-1.061l4.927,4.927a.75.75,0,0,1-1.049,1.073ZM1.5,8.114A6.614,6.614,0,1,0,8.114,1.5,6.621,6.621,0,0,0,1.5,8.114Z"
                transform="translate(2.25 2.25)"
                fill="#174a7c"
              />
            </g>
          </svg>
        </a>
        <a
          id="remove"
          class="btn btn-link hover-red d-inline-flex align-items-center text-nowrap p-0"
          tabindex="0"
          (click)="removeItem(i)"
        >
          <span class="pe-2">{{ "REMOVE" | globalTranslate }}</span>
          <nh-remove-svg></nh-remove-svg>
        </a>
      </div>
    </div>
    }
  </div>
  } @if (displayLoading) {
  <div class="row uploaded-documentname">
    <div class="col-8">
      <span class="pe-2 file-icon"
        ><img
          alt=""
          src="../../../../../../assets/images/⚛️ icons-document-attach-outline.svg"
          aria-hidden="true"
          role="presentation"
      /></span>
      <span class="file-name" style="max-width: 440px">{{ docName }}</span>
    </div>
    <div class="col-4">
      <div class="option-lables">
        <img
          src="../../../../../../assets/images/⚛️ File_Uploader_Loader.svg"
        />
      </div>
    </div>
  </div>
  }

  <div>
    <div class="d-flex align-items-start mt-3">
      <div class="ms-2">
        <button
          id="addAnother"
          (click)="addAnother()"
          class="btn btn-outline-secondary btn-add-another align-items-center"
          [hidden]="error"
          [attr.aria-label]="
            ridpFlow
              ? ('ADD_PAGE_2' | globalTranslate)
              : ('ADD_1' | globalTranslate)
          "
          [style.font-size]="ridpFlow ? getRidpFontSize() : null"
          [ngClass]="{
            'less-width-more-font-translate': lesswidthFontSize(),
            'more-width-less-font-translate': extrawidthFontSize(),
            'ridp-button-translate': ridpButtonTranslate(ridpFlow)
          }"
        >
          {{
            ridpFlow
              ? ("ADD_PAGE_2" | globalTranslate)
              : ("ADD_1" | globalTranslate)
          }}
          <svg
            id="_icons_add-circle-outline"
            data-name="⚛️ icons/add-circle-outline"
            xmlns="http://www.w3.org/2000/svg"
            [attr.width]="
              ridpFlow ? (translatedLang !== 'en' ? '16' : '20') : '24'
            "
            [attr.height]="
              ridpFlow ? (translatedLang !== 'en' ? '16' : '20') : '24'
            "
            viewBox="0 0 24 24"
          >
            <path
              id="Combined_Shape"
              data-name="Combined Shape"
              d="M0,9.75A9.75,9.75,0,1,1,9.75,19.5,9.761,9.761,0,0,1,0,9.75Zm1.5,0A8.25,8.25,0,1,0,9.75,1.5,8.259,8.259,0,0,0,1.5,9.75ZM9,13.514V10.5H6A.75.75,0,0,1,5.985,9H9V6a.75.75,0,0,1,1.5-.015V9h3a.75.75,0,0,1,.014,1.5H10.5v3a.75.75,0,0,1-1.5.014Z"
              transform="translate(2.25 2.25)"
              fill="#174a7c"
            />
          </svg>
        </button>
      </div>
      <div class="ms-2">
        <button
          [hidden]="
            error || showCZPRmessage || (ridpFlow && showAddressWarning)
          "
          routerLinkActive="active"
          (click)="submitDocuments('desktop')"
          id="continue"
          class="btn btn-secondary"
        >
          {{ "SUBMIT" | globalTranslate }}
        </button>
      </div>
    </div>
  </div>

  @if (showCZPRmessage) {
  <div style="border: 0px solid #f5e0af; margin-top: 15px">
    {{ "UPLOAD_DOC_TEXT2" | globalTranslate }}
  </div>
  }
</div>
@if (ridpFlow && showAddressWarning) {
<div class="ridp-supporting-upload-section d-none d-lg-block">
  <!-- Yellow warning banner (nh-alert matches existing banner pattern) -->
  <nh-alert type="warning" [isOpen]="true" id="supportingdoc_warning">
    <div class="d-flex align-items-center">
      <div class="me-2">
        <img
          src="../../../../../../assets/images/Icons/⚛️ icons-warning-outline.svg"
          alt=""
          aria-hidden="true"
        />
      </div>
      <div>
        <span [innerHTML]="'RIDP_DL_ADDRESS_WARNING' | globalTranslate"></span>
        <span>{{ "RIDP_DL_ADDRESS_WARNING_01" | globalTranslate }}?</span>
        <span
          [innerHTML]="'RIDP_DL_ADDRESS_WARNING_02' | globalTranslate"
        ></span>
      </div>
    </div>
  </nh-alert>
  <!-- Supporting Document section (shown after clicking Supporting Document Upload) -->
  @if (showSupportingDocUpload) {
  <div class="ridp-supporting-doc-content mt-3">
    <div class="mb-2">
      <div class="col-md-12">
        <span class="text-danger" aria-hidden="true">*</span>
        <label class="label-section">{{
          "RIDP_SUPPORTING_DOC_TYPE" | globalTranslate
        }}</label>
        <div class="mt-2 d-lg-flex">
          <select
            class="custom-select-info"
            [attr.aria-label]="'RIDP_SUPPORTING_DOC_TYPE' | globalTranslate"
            [(ngModel)]="supportingDocuments[0].docType"
            (change)="selectedSupportingOption()"
          >
            <option [ngValue]="null">
              {{ "PICK_AN_OPTION" | globalTranslate }}
            </option>
            @for (option of supportingDocOptions; track option) {
            <option [ngValue]="option">
              {{
                translatedLang === "en"
                  ? (option.enDescription | globalTranslate)
                  : option.spDescription
              }}
            </option>
            }
          </select>
          @if (!supportingDocuments[0]?.file) {
          <div class="col-md-2 d-flex align-items-end pb-1">
            <div class="ps-1 pt-1 hover-red upload-btn-close">
              <a
                role="button"
                tabindex="0"
                (click)="cancelSupportingDocUpload()"
                (keydown.enter)="
                  cancelSupportingDocUpload(); $event.preventDefault()
                "
                (keydown.space)="
                  cancelSupportingDocUpload(); $event.preventDefault()
                "
                ><span class="pe-2">{{ "CLOSE" | globalTranslate }}</span
                ><i class="fa fa-times-circle" aria-hidden="true"></i
              ></a>
            </div>
          </div>
          }
        </div>
      </div>
    </div>
    @for (sdoc of supportingDocuments; track sdoc; let si = $index) {
    <div>
      @if (!sdoc.file && si !== 0) {
      <div class="col-md-2 offset-md-4">
        <div class="ps-1 pt-1 hover-red upload-btn-close">
          <a
            role="button"
            tabindex="0"
            (click)="closeSupportingDoc(si)"
            (keydown.enter)="closeSupportingDoc(si); $event.preventDefault()"
            (keydown.space)="closeSupportingDoc(si); $event.preventDefault()"
            ><span class="pe-2">{{ "CLOSE" | globalTranslate }}</span
            ><i class="fa fa-times-circle" aria-hidden="true"></i
          ></a>
        </div>
      </div>
      } @if (sdoc.show && sdoc.docType) {
      <div class="row pt-2">
        <div class="col-md-12">
          <nh-file-upload
            (passFileData)="getSupportingFileDetails($event, si)"
            (fileUploadStarted)="getSupportingFileProgress($event)"
          >
          </nh-file-upload>
        </div>
      </div>
      } @if (supportingDisplayLoading) {
      <div class="row uploaded-documentname">
        <div class="col-8">
          <span class="pe-2 file-icon"
            ><img
              alt=""
              src="../../../../../../assets/images/⚛️ icons-document-attach-outline.svg"
              aria-hidden="true"
              role="presentation"
          /></span>
          <span class="file-name" style="max-width: 440px">{{
            supportingDocName
          }}</span>
        </div>
        <div class="col-4">
          <div class="option-lables">
            <img
              src="../../../../../../assets/images/⚛️ File_Uploader_Loader.svg"
            />
          </div>
        </div>
      </div>
      } @if (sdoc.file) {
      <div
        class="uploaded-documentname p-2 mt-2 d-flex align-items-center flex-wrap"
      >
        <div class="pe-2 flex-shrink-0">
          <img
            alt=""
            aria-hidden="true"
            role="presentation"
            src="../../../../../../assets/images/⚛️ icons-document-attach-outline.svg"
          />
        </div>
        <div class="me-3 text-truncate min-w-0" style="max-width: 440px">
          <span>{{ sdoc.file.name }}</span>
        </div>
        <div
          class="hover-red option-lables ms-3 d-inline-flex align-items-center gap-3"
        >
          <a
            class="btn btn-link hover-red d-inline-flex align-items-center text-nowrap p-0"
            tabindex="0"
            (click)="viewSupportingPdf(si)"
          >
            <span class="pe-2">{{ "View" | globalTranslate }}</span>
            <svg
              id="_icons_search-outline-sp"
              data-name="⚛️ icons/search-outline"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              width="24"
              height="24"
              viewBox="0 0 24 24"
            >
              <defs>
                <clipPath id="clip-path-supporting">
                  <rect id="Background" width="24" height="24" fill="#174a7c" />
                </clipPath>
              </defs>
              <g id="Mask_Group_sp" clip-path="url(#clip-path-supporting)">
                <path
                  id="Combined_Shape_sp"
                  data-name="Combined Shape"
                  d="M18.232,19.292l-.013-.012-4.927-4.927a8.122,8.122,0,1,1,1.061-1.061l4.927,4.927a.75.75,0,0,1-1.049,1.073ZM1.5,8.114A6.614,6.614,0,1,0,8.114,1.5,6.621,6.621,0,0,0,1.5,8.114Z"
                  transform="translate(2.25 2.25)"
                  fill="#174a7c"
                />
              </g>
            </svg>
          </a>
          <a
            class="btn btn-link hover-red d-inline-flex align-items-center text-nowrap p-0"
            tabindex="0"
            (click)="removeSupportingItem(si)"
          >
            <span class="pe-2">{{ "REMOVE" | globalTranslate }}</span>
            <nh-remove-svg></nh-remove-svg>
          </a>
        </div>
      </div>
      }
    </div>
    }
  </div>
  }
  <!-- Bottom actions: Supporting Doc Upload toggle + close + Submit -->
  <div class="d-lg-flex align-items-start mt-3 mb-1">
    @if (!showSupportingDocUpload) {
    <div class="ms-2 me-5">
      <button
        (click)="openSupportingDocUpload()"
        id="supportingDocUploadBtn"
        class="btn btn-outline-secondary btn-add-another align-items-center"
      >
        {{ "RIDP_SUPPORTING_DOC_UPLOAD_BTN" | globalTranslate }}
        <svg
          data-name="⚛️ icons/add-circle-outline"
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 24 24"
        >
          <path
            data-name="Combined Shape"
            d="M0,9.75A9.75,9.75,0,1,1,9.75,19.5,9.761,9.761,0,0,1,0,9.75Zm1.5,0A8.25,8.25,0,1,0,9.75,1.5,8.259,8.259,0,0,0,1.5,9.75ZM9,13.514V10.5H6A.75.75,0,0,1,5.985,9H9V6a.75.75,0,0,1,1.5-.015V9h3a.75.75,0,0,1,.014,1.5H10.5v3a.75.75,0,0,1-1.5.014Z"
            transform="translate(2.25 2.25)"
            fill="#174a7c"
          />
        </svg>
      </button>
    </div>
    } @if (showSupportingDocUpload) {
    <div class="ms-2">
      <button
        (click)="addSupportingPage()"
        id="addAnother"
        class="btn btn-outline-secondary btn-add-another align-items-center"
        [hidden]="supportingDocError"
        [attr.aria-label]="
          ridpFlow
            ? ('ADD_PAGE_2' | globalTranslate)
            : ('ADD_1' | globalTranslate)
        "
        [style.font-size]="ridpFlow ? getRidpFontSize() : null"
        [ngClass]="{
          'less-width-more-font-translate': lesswidthFontSize(),
          'more-width-less-font-translate': extrawidthFontSize(),
          'ridp-button-translate': ridpButtonTranslate(ridpFlow)
        }"
      >
        {{ "ADD_PAGE_2" | globalTranslate }}
        <svg
          id="_icons_add-circle-outline"
          data-name="⚛️ icons/add-circle-outline"
          xmlns="http://www.w3.org/2000/svg"
          [attr.width]="
            ridpFlow ? (translatedLang !== 'en' ? '16' : '20') : '24'
          "
          [attr.height]="
            ridpFlow ? (translatedLang !== 'en' ? '16' : '20') : '24'
          "
          viewBox="0 0 24 24"
        >
          <path
            id="Combined_Shape"
            data-name="Combined Shape"
            d="M0,9.75A9.75,9.75,0,1,1,9.75,19.5,9.761,9.761,0,0,1,0,9.75Zm1.5,0A8.25,8.25,0,1,0,9.75,1.5,8.259,8.259,0,0,0,1.5,9.75ZM9,13.514V10.5H6A.75.75,0,0,1,5.985,9H9V6a.75.75,0,0,1,1.5-.015V9h3a.75.75,0,0,1,.014,1.5H10.5v3a.75.75,0,0,1-1.5.014Z"
            transform="translate(2.25 2.25)"
            fill="#174a7c"
          />
        </svg>
      </button>
    </div>
    }
    <div [ngClass]="{ 'ms-5': showSupportingDocUpload && !supportingDocError }">
      <button
        (click)="submitDocuments('desktop')"
        [disabled]="error || (showSupportingDocUpload && supportingDocError)"
        class="btn btn-secondary"
      >
        {{ "SUBMIT" | globalTranslate }}
      </button>
    </div>
  </div>
</div>
}

<div class="p-1 mt-1 nh-table-mobile d-lg-none">
  @if (!successDocUpload) {
  <div>
    @if (!ridpFlow) {
    <div>
      <h1 class="section-header">{{ "UPLOAD_DOCUMENT1" | globalTranslate }}</h1>
      <hr />
      @if (!isMobileView && !uploadDocumentFlag) {
      <ngx-datatable
        class="bootstrap striped"
        limit="5"
        #table
        [rows]="rows"
        [columnMode]="'force'"
        [headerHeight]="'auto'"
        [footerHeight]="50"
        [rowHeight]="'auto'"
      >
        @for (col of columns; track col) {
        <ngx-datatable-column
          [name]="col.name | globalTranslate"
          [prop]="col.prop"
        >
        </ngx-datatable-column>
        }
      </ngx-datatable>
      } @if (uploadDocumentFlag) {
      <ngx-datatable
        class="bootstrap striped"
        limit="5"
        #table
        [rows]="rowsData"
        [headerHeight]="'auto'"
        [footerHeight]="50"
        [rowHeight]="'auto'"
        [columnMode]="'force'"
      >
        <ngx-datatable-column [name]="'Name' | globalTranslate" prop="fullName">
          <ng-template ngx-datatable-cell-template let-value="value">
            <span>{{ value }}</span>
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column
          [name]="'Proof Type' | globalTranslate"
          prop="verfDesc"
        >
          <ng-template ngx-datatable-cell-template let-value="value">
            <span>{{ value | globalTranslate }}</span>
          </ng-template>
        </ngx-datatable-column>
      </ngx-datatable>
      } @if (isMobileView && !row?.refId && uploadDocumentFlag) {
      <div>
        @if (rowsData.length) { @for (row of rowsData; track row) {
        <div>
          <p>
            <strong>{{ columnData[0].name | globalTranslate }}</strong>
          </p>
          <hr />
          <p>{{ row?.fullName }}</p>
          <br />
          <p>
            <strong>{{ columnData[1].name | globalTranslate }}</strong>
          </p>
          <hr />
          @if (translatedLang === 'en') {
          <p>{{ row?.verfDesc | globalTranslate }}</p>
          }
        </div>
        } } @if (!rows.length) {
        <p class="mb-5">{{ "NO_DATA_TO_DISPLAY" | globalTranslate }}</p>
        }
      </div>
      } @if (isMobileView && !row?.refId && isMedicalAppeal) {
      <div>
        @if (rows.length) { @for (row of rows; track row) {
        <div>
          <p>
            <strong>{{ columns[0].name | globalTranslate }}</strong>
          </p>
          <hr />
          <p>{{ row?.fullName }}</p>
          <br />
          <p>
            <strong>{{ columns[1].name | globalTranslate }}</strong>
          </p>
          <hr />
          @if (isMedicalAppeal) {
          <p>{{ row?.verfDesc | globalTranslate }}</p>
          }
          <br />
          @if ((row.verfDesc === 'Additional Information Form' || row.verfDesc
          === 'Formulario para Información Adicional')) {
          <div>
            <p>
              <strong>{{ columns[2].name | globalTranslate }}</strong>
            </p>
            <hr />
            <p>{{ row?.appealDueDate }}</p>
            <br />
          </div>
          }
        </div>
        } } @if (!rows.length) {
        <p class="mb-5">{{ "NO_DATA_TO_DISPLAY" | globalTranslate }}</p>
        }
      </div>
      } @if (isMobileView && !row?.refId && !uploadDocumentFlag &&
      !isMedicalAppeal) {
      <div>
        @if (rows.length) { @for (row of rows; track row) {
        <div>
          <p>
            <strong>{{ columns[0].name | globalTranslate }}</strong>
          </p>
          <hr />
          <p>{{ row?.fullName }}</p>
          <br />
          <p>
            <strong>{{ columns[1].name | globalTranslate }}</strong>
          </p>
          <hr />
          @if (translatedLang === 'en') {
          <p>{{ row?.proofType | globalTranslate }}</p>
          } @if (translatedLang !== 'en') {
          <p>{{ row?.proofTypeEs }}</p>
          }
          <br />
          <p>
            <strong>{{ columns[2].name | globalTranslate }}</strong>
          </p>
          <hr />
          <p>{{ row?.proofRequiredValue | globalTranslate }}</p>
          <br />
          @if (!(row?.verfDesc === 'Documents for Appeals' || row?.verfDesc ===
          'Documentos para Apelaciones' || row?.verfDesc === 'Appeal Facts
          Documents' || row?.verfDesc === 'Documento de información para la
          apelación')) {
          <div>
            <p>
              <strong>{{ columns[3].name | globalTranslate }}</strong>
            </p>
            <hr />
            <p>{{ row?.verfDue }}</p>
            <br />
          </div>
          }
        </div>
        } } @if (!rows.length) {
        <p class="mb-5">{{ "NO_DATA_TO_DISPLAY" | globalTranslate }}</p>
        }
      </div>
      } @if (translatedLang === 'en' && !uploadDocumentFlag &&
      !isKatieDocUpload) {
      <h2 class="section-header">
        {{ row?.fullName }}'s {{this.rows[0]?.['proofType'] | globalTranslate}}
      </h2>
      } @if (translatedLang !== 'en' && !uploadDocumentFlag &&
      !isKatieDocUpload) {
      <h2 class="section-header">
        {{ row?.fullName }}'s {{this.rows[0]?.['proofTypeEs']}}
      </h2>
      } @if (translatedLang === 'en' && !uploadDocumentFlag && isKatieDocUpload)
      {
      <h2 class="section-header">
        {{ row?.fullName }}'s {{ this.vfdProofType | globalTranslate }}
      </h2>
      } @if (translatedLang !== 'en' && !uploadDocumentFlag && isKatieDocUpload)
      {
      <h2 class="section-header">
        {{ row?.fullName }}'s {{ this.vfdProofType }}
      </h2>
      } @if (translatedLang === 'en' && uploadDocumentFlag) {
      <h2 class="section-header">
        {{ row?.fullName }}'s {{ this.vfdProofType | globalTranslate }}
      </h2>
      } @if (translatedLang !== 'en' && uploadDocumentFlag) {
      <h2 class="section-header">
        {{ row?.fullName }}'s {{ this.vfdProofType }}
      </h2>
      }
      <hr />
      @if (error) {
      <p
        class="static-text"
        [innerHtml]="'DOC_BEFORE_UPLOAD_TEXT' | globalTranslate"
      ></p>
      } @if (!error) {
      <p
        class="static-text"
        [innerHtml]="'DOC_AFTER_UPLOAD_TEXT' | globalTranslate"
      ></p>
      }
    </div>
    } @if (ridpFlow) {
    <div>
      <h2 class="section-header">
        {{ "RIDP_UPLOADDOC_STATIC1" | globalTranslate }}
      </h2>
      <hr />
      <p [innerHTML]="'RIDP_UPLOADDOC_STATIC2' | globalTranslate"></p>
      <div class="pb-3 popup">
        <a
          title="{{ 'RIDP_UPLOADDOC_STATIC3' | globalTranslate }}"
          role="link"
          tabindex="0"
          (click)="showDocTypes()"
          (keydown.enter)="showDocTypes(); $event.preventDefault()"
          (keydown.space)="showDocTypes(); $event.preventDefault()"
        >
          <span class="pe-2">{{
            "RIDP_UPLOADDOC_STATIC3" | globalTranslate
          }}</span>
          <span><i class="fa fa-external-link" aria-hidden="true"></i></span>
        </a>
      </div>
    </div>
    } @for (doc of diffDocTypes; track doc; let i = $index) {
    <div>
      <div class="row">
        <div class="col-md-12">
          <span class="text-danger" aria-hidden="true">*</span
          ><label for="docType" class="label-section">{{
            (ridpFlow ? "ID_VERIFY_DOC_TYPE" : "DOCUMENT_TYPE")
              | globalTranslate
          }}</label>
          @if (!ridpFlow) {
          <p
            class="static-text"
            [innerHtml]="'DOCUMENT_TEXT' | globalTranslate"
          ></p>
          }
          <div class="mt-3">
            @if (translatedLang === 'en') {
            <select
              class="custom-select-info"
              aria-label="documentType"
              [(ngModel)]="doc.docType"
              name="doc.docType"
              (change)="selectedOptionMobile(i)"
              required
            >
              <option [ngValue]="null">
                {{ "PICK_AN_OPTION" | globalTranslate }}
              </option>
              @for (option of options; track option) {
              <option [ngValue]="option">
                {{ option.enDescription | globalTranslate }}
              </option>
              }
            </select>
            } @if (translatedLang !== 'en') {
            <select
              class="custom-select-info"
              aria-label="tipo de documento"
              [(ngModel)]="doc.docType"
              name="doc.docType"
              (change)="selectedOptionMobile(i)"
              required
            >
              <option [ngValue]="null">Elija una opción</option>
              @for (option of options; track option) {
              <option [ngValue]="option">{{ option.spDescription }}</option>
              }
            </select>
            }
          </div>
          @if (doc.error) {
          <div class="error-messages position-relative">
            <span class="form-text invalid-tooltip d-block">
              <ng-container>{{ "REQUIRED" | globalTranslate }}</ng-container>
            </span>
          </div>
          }
        </div>
        @if (!doc.file && i !== 0 && doc.docType?.code && displayUpload) {
        <div class="col-md-2 offset-md-4">
          <div
            class="row ps-3 pt-1 hover-red upload-btn-close"
            style="float: right"
          >
            <a
              role="button"
              tabindex="0"
              (click)="closeMobile()"
              (keydown.enter)="closeMobile(); $event.preventDefault()"
              (keydown.space)="closeMobile(); $event.preventDefault()"
              ><span class="pe-2">{{ "CLOSE" | globalTranslate }}</span
              ><i class="fa fa-times-circle" aria-hidden="true"></i
            ></a>
          </div>
        </div>
        }
      </div>
      @if (doc.show && doc.docType?.code) {
      <div class="pt-2">
        <div class="col-md-12">
          <nh-mobile-file-upload
            (passFileData)="getFileDetailsMobile($event, i)"
            (fileUploadStarted)="getFileProgress($event)"
            [displayLoading]="displayLoading"
          >
          </nh-mobile-file-upload>
        </div>
      </div>
      } @if (doc.file) {
      <div class="d-flex align-items-center p-3">
        <div class="row uploaded-documentname">
          <div class="pe-2 file-icon">
            <img
              alt=""
              aria-hidden="true"
              role="presentation"
              src="../../../../../../assets/images/⚛️ icons-document-attach-outline.svg"
            />
          </div>
          @if (doc.commonItems?.length > 1) {
          <div class="file-name" style="max-width: 440px">
            <span
              >{{ doc.commonItems.length }}
              {{ "DOCUMENTS_UPLOADED" | globalTranslate }}</span
            >
          </div>
          } @if (doc.commonItems.length === 1) {
          <div class="file-name" style="max-width: 440px">
            <span>1 {{ "DOCUMENT_ONE_UPLOADED" | globalTranslate }}</span>
          </div>
          }
          <div class="hover-red option-lables pt-2">
            <a
              id="edit"
              tabindex="0"
              class="p-0 pb-1 pe-5 btn btn-link btn-lg hover-red"
              (click)="onEdit(i, doc)"
            >
              <span>{{ "EDIT_OR_VIEW" | globalTranslate }} </span>
              <svg
                id="_icons_search-outline"
                data-name="⚛️ icons/search-outline"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                width="24"
                height="24"
                viewBox="0 0 24 24"
              >
                <defs>
                  <clipPath id="clip-path">
                    <rect
                      id="Background"
                      width="24"
                      height="24"
                      fill="#174a7c"
                    />
                  </clipPath>
                </defs>
                <g
                  id="Mask_Group_1"
                  data-name="Mask Group 1"
                  clip-path="url(#clip-path)"
                >
                  <path
                    id="Combined_Shape"
                    data-name="Combined Shape"
                    d="M18.232,19.292l-.013-.012-4.927-4.927a8.122,8.122,0,1,1,1.061-1.061l4.927,4.927a.75.75,0,0,1-1.049,1.073ZM1.5,8.114A6.614,6.614,0,1,0,8.114,1.5,6.621,6.621,0,0,0,1.5,8.114Z"
                    transform="translate(2.25 2.25)"
                    fill="#174a7c"
                  />
                </g>
              </svg>
            </a>
            <a
              id="remove"
              class="p-0 pb-1 btn btn-link hover-red"
              tabindex="0"
              (click)="removeItemMobile(i)"
            >
              <span class="pe-2">{{ "REMOVE" | globalTranslate }}</span>
              <nh-remove-svg></nh-remove-svg>
            </a>
          </div>
        </div>
      </div>
      }
    </div>
    } @if (displayLoading) {
    <div class="row uploaded-documentname">
      <div class="col-8">
        <span class="pe-2 file-icon"
          ><img
            alt=""
            aria-hidden="true"
            role="presentation"
            src="../../../../../../assets/images/⚛️ icons-document-attach-outline.svg"
        /></span>
        <span class="file-name" style="max-width: 440px">{{ docName }}</span>
      </div>
      <div class="col-4">
        <div class="option-lables">
          <img
            src="../../../../../../assets/images/⚛️ File_Uploader_Loader.svg"
          />
        </div>
      </div>
    </div>
    }
    <div>
      <div class="align-items-start mt-3">
        @if (!ridpFlow) {
        <div class="ms-2">
          <button
            id="addAnother"
            (click)="addAnotherMobile()"
            class="btn btn-outline-secondary btn-add-another align-items-center"
            [hidden]="error"
            [attr.aria-label]="'ADD_1' | globalTranslate"
            [ngClass]="{
              'less-width-more-font-translate': lesswidthFontSize(),
              'more-width-less-font-translate': extrawidthFontSize()
            }"
          >
            {{ "ADD_1" | globalTranslate }}
            <svg
              id="_icons_add-circle-outline"
              data-name="⚛️ icons/add-circle-outline"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
            >
              <path
                id="Combined_Shape"
                data-name="Combined Shape"
                d="M0,9.75A9.75,9.75,0,1,1,9.75,19.5,9.761,9.761,0,0,1,0,9.75Zm1.5,0A8.25,8.25,0,1,0,9.75,1.5,8.259,8.259,0,0,0,1.5,9.75ZM9,13.514V10.5H6A.75.75,0,0,1,5.985,9H9V6a.75.75,0,0,1,1.5-.015V9h3a.75.75,0,0,1,.014,1.5H10.5v3a.75.75,0,0,1-1.5.014Z"
                transform="translate(2.25 2.25)"
                fill="#174a7c"
              />
            </svg>
          </button>
        </div>
        }
        <div class="ms-2">
          <button
            [hidden]="
              error || showCZPRmessage || (ridpFlow && showAddressWarning)
            "
            routerLinkActive="active"
            (click)="submitDocuments('mobileBrowser')"
            id="continue"
            class="btn btn-secondary"
          >
            {{ "SUBMIT" | globalTranslate }}
          </button>
        </div>
      </div>
    </div>
    @if (showCZPRmessage) {
    <div style="border: 0px solid #f5e0af; margin-top: 15px">
      {{ "UPLOAD_DOC_TEXT2" | globalTranslate }}
    </div>
    }
    <!-- RIDP mobile: Address Warning Banner + Supporting Document Upload -->
    @if (ridpFlow && showAddressWarning) {
    <div class="ridp-supporting-upload-section">
      <nh-alert type="warning" [isOpen]="true">
        <div class="d-flex align-items-center">
          <div class="me-2">
            <img
              src="../../../../../../assets/images/Icons/⚛️ icons-warning-outline.svg"
              alt=""
              aria-hidden="true"
            />
          </div>
          <div>
            <span
              [innerHTML]="'RIDP_DL_ADDRESS_WARNING' | globalTranslate"
            ></span>
            <span>{{ "RIDP_DL_ADDRESS_WARNING_01" | globalTranslate }}?</span>
            <span
              [innerHTML]="'RIDP_DL_ADDRESS_WARNING_02' | globalTranslate"
            ></span>
          </div>
        </div>
      </nh-alert>
      @if (showSupportingDocUpload) {
      <div class="ridp-supporting-doc-content mt-3">
        <div class="mb-2">
          <div class="col-md-12">
            <span class="text-danger" aria-hidden="true">*</span>
            <label class="label-section">{{
              "RIDP_SUPPORTING_DOC_TYPE" | globalTranslate
            }}</label>
            <div class="mt-2">
              <select
                class="custom-select-info"
                [attr.aria-label]="'RIDP_SUPPORTING_DOC_TYPE' | globalTranslate"
                [(ngModel)]="supportingDocuments[0].docType"
                (change)="selectedSupportingOption()"
              >
                <option [ngValue]="null">
                  {{ "PICK_AN_OPTION" | globalTranslate }}
                </option>
                @for (option of supportingDocOptions; track option) {
                <option [ngValue]="option">
                  {{
                    translatedLang === "en"
                      ? (option.enDescription | globalTranslate)
                      : option.spDescription
                  }}
                </option>
                }
              </select>
            </div>
            @if (!supportingDocuments[0]?.file) {
            <div class="mt-2">
              <a
                role="button"
                tabindex="0"
                (click)="cancelSupportingDocUpload()"
                (keydown.enter)="
                  cancelSupportingDocUpload(); $event.preventDefault()
                "
                (keydown.space)="
                  cancelSupportingDocUpload(); $event.preventDefault()
                "
                class="mobile-upload-btn-close"
                ><span class="pe-2">{{ "CLOSE" | globalTranslate }}</span
                ><i class="fa fa-times-circle" aria-hidden="true"></i
              ></a>
            </div>
            }
          </div>
        </div>
        @for (sdoc of supportingDocuments; track sdoc; let si = $index) {
        <div>
          @if (!sdoc.file && si !== 0) {
          <div class="mt-2">
            <a
              role="button"
              tabindex="0"
              (click)="closeSupportingDoc(si)"
              (keydown.enter)="closeSupportingDoc(si); $event.preventDefault()"
              (keydown.space)="closeSupportingDoc(si); $event.preventDefault()"
              class="mobile-upload-btn-close"
              ><span class="pe-2">{{ "CLOSE" | globalTranslate }}</span
              ><i class="fa fa-times-circle" aria-hidden="true"></i
            ></a>
          </div>
          } @if (sdoc.show && sdoc.docType) {
          <div class="pt-2">
            <div class="col-md-12 mt-4">
              <nh-mobile-file-upload
                (passFileData)="getSupportingFileDetailsMobile($event, si)"
                (fileUploadStarted)="getSupportingFileProgress($event)"
                [displayLoading]="supportingDisplayLoading"
              >
              </nh-mobile-file-upload>
            </div>
          </div>
          } @if (supportingDisplayLoading) {
          <div class="row uploaded-documentname">
            <div class="col-8">
              <span class="pe-2 file-icon"
                ><img
                  alt=""
                  aria-hidden="true"
                  role="presentation"
                  src="../../../../../../assets/images/⚛️ icons-document-attach-outline.svg"
              /></span>
              <span class="file-name" style="max-width: 440px">{{
                supportingDocName
              }}</span>
            </div>
            <div class="col-4">
              <div class="option-lables">
                <img
                  src="../../../../../../assets/images/⚛️ File_Uploader_Loader.svg"
                />
              </div>
            </div>
          </div>
          }
        </div>
        }
      </div>
      }
      <!-- Summary count for uploaded supporting docs - matches main section style -->
      @if (uploadedSupportingCount > 0) {
      <div class="d-flex align-items-center p-3">
        <div class="row uploaded-documentname">
          <div class="pe-2 file-icon">
            <img
              alt=""
              aria-hidden="true"
              role="presentation"
              src="../../../../../../assets/images/⚛️ icons-document-attach-outline.svg"
            />
          </div>
          @if (uploadedSupportingCount > 1) {
          <div class="file-name" style="max-width: 440px">
            <span
              >{{ uploadedSupportingCount }}
              {{ "DOCUMENTS_UPLOADED" | globalTranslate }}</span
            >
          </div>
          } @if (uploadedSupportingCount === 1) {
          <div class="file-name" style="max-width: 440px">
            <span>1 {{ "DOCUMENT_ONE_UPLOADED" | globalTranslate }}</span>
          </div>
          }
          <div class="hover-red option-lables pt-2">
            <a
              tabindex="0"
              class="p-0 pb-1 pe-5 btn btn-link btn-lg hover-red"
              (click)="onEditSupportingDoc(0, 'supporting')"
            >
              <span>{{ "EDIT_OR_VIEW" | globalTranslate }}</span>
              <svg
                data-name="⚛️ icons/search-outline"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                width="24"
                height="24"
                viewBox="0 0 24 24"
              >
                <defs>
                  <clipPath id="clip-path-supp-sum">
                    <rect width="24" height="24" fill="#174a7c" />
                  </clipPath>
                </defs>
                <g clip-path="url(#clip-path-supp-sum)">
                  <path
                    d="M18.232,19.292l-.013-.012-4.927-4.927a8.122,8.122,0,1,1,1.061-1.061l4.927,4.927a.75.75,0,0,1-1.049,1.073ZM1.5,8.114A6.614,6.614,0,1,0,8.114,1.5,6.621,6.621,0,0,0,1.5,8.114Z"
                    transform="translate(2.25 2.25)"
                    fill="#174a7c"
                  />
                </g>
              </svg>
            </a>
            <a
              class="p-0 pb-1 btn btn-link hover-red"
              tabindex="0"
              (click)="removeAllSupportingItemsMobile()"
            >
              <span class="pe-2">{{ "REMOVE" | globalTranslate }}</span>
              <nh-remove-svg></nh-remove-svg>
            </a>
          </div>
        </div>
      </div>
      }
      <div class="align-items-start mt-3 mb-1">
        <div class="ms-md-2">
          @if (!showSupportingDocUpload) {
          <button
            (click)="openSupportingDocUpload()"
            id="supportingDocUploadBtn"
            class="btn btn-outline-secondary btn-add-another align-items-center"
          >
            {{ "RIDP_SUPPORTING_DOC_UPLOAD_BTN" | globalTranslate }}
            <svg
              data-name="⚛️ icons/add-circle-outline"
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
            >
              <path
                data-name="Combined Shape"
                d="M0,9.75A9.75,9.75,0,1,1,9.75,19.5,9.761,9.761,0,0,1,0,9.75Zm1.5,0A8.25,8.25,0,1,0,9.75,1.5,8.259,8.259,0,0,0,1.5,9.75ZM9,13.514V10.5H6A.75.75,0,0,1,5.985,9H9V6a.75.75,0,0,1,1.5-.015V9h3a.75.75,0,0,1,.014,1.5H10.5v3a.75.75,0,0,1-1.5.014Z"
                transform="translate(2.25 2.25)"
                fill="#174a7c"
              />
            </svg>
          </button>
          }
        </div>
        <div>
          <button
            (click)="submitDocuments('mobileBrowser')"
            [disabled]="
              error || (showSupportingDocUpload && supportingDocError)
            "
            class="btn btn-secondary submit-btn"
          >
            {{ "SUBMIT" | globalTranslate }}
          </button>
        </div>
      </div>
    </div>
    }
  </div>
  }

  <!-- new screen chanages start -->
  @if (successDocUpload) {
  <div class="col-md-12">
    <span [innerHTML]="'REVAMP_MOBILEDOC_STATIC1' | globalTranslate"></span
    ><br /><br />
    @if (!changeType) {
    <h2
      class="section-header mt-0 ms-0"
      style="text-align: center; padding-top: 0px"
    >
      {{ currentDocType | globalTranslate }}
    </h2>
    } @if (!changeType) {
    <div class="ms-0" style="text-align: center">
      <button
        (click)="clickChangeType()"
        id="changeType"
        class="btn btn-secondary"
        style="
          min-width: 200px;
          height: 38px;
          font: normal normal bold 18px / 20px Open Sans !important;
        "
      >
        {{ "CHANGE_TYPE" | globalTranslate }}
      </button>
    </div>
    } @if (changeType && !isSupportingDocFlow) {
    <div class="col-md-12">
      <span class="text-danger" aria-hidden="true">*</span
      ><label class="label-section">{{
        (ridpFlow ? "ID_VERIFY_DOC_TYPE" : "DOCUMENT_TYPE") | globalTranslate
      }}</label
      ><span class="visually-hidden">{{ "required" | globalTranslate }}</span>
      <div class="mt-3">
        @if (translatedLang === 'en') {
        <select
          class="custom-select-info"
          aria-label="documentType"
          [(ngModel)]="diffDocTypes[currentI].docType"
          name="diffDocTypes[currentI].docType"
          (change)="selectedOptionMobile(currentI)"
          required
        >
          <option [ngValue]="null">
            {{ "PICK_AN_OPTION" | globalTranslate }}
          </option>
          @for (option of options; track option) {
          <option [ngValue]="option">
            {{ option.enDescription | globalTranslate }}
          </option>
          }
        </select>
        } @if (translatedLang !== 'en') {
        <select
          class="custom-select-info"
          aria-label="tipo de documento"
          [(ngModel)]="diffDocTypes[currentI].docType"
          name="diffDocTypes[currentI].docType"
          (change)="selectedOptionMobile(currentI)"
          required
        >
          <option [ngValue]="null">Elija una opción</option>
          @for (option of options; track option) {
          <option [ngValue]="option">{{ option.spDescription }}</option>
          }
        </select>
        }
      </div>
      @if (diffDocTypes[currentI]?.error) {
      <div class="error-messages position-relative">
        <span class="form-text invalid-tooltip d-block">
          <ng-container>{{ "REQUIRED" | globalTranslate }}</ng-container>
        </span>
      </div>
      }
    </div>
    } @if (changeType && isSupportingDocFlow) {
    <div class="col-md-12">
      <span class="text-danger" aria-hidden="true">*</span
      ><label class="label-section">{{
        "RIDP_SUPPORTING_DOC_TYPE" | globalTranslate
      }}</label>
      <div class="mt-3">
        <select
          class="custom-select-info"
          [attr.aria-label]="'RIDP_SUPPORTING_DOC_TYPE' | globalTranslate"
          [(ngModel)]="supportingDocuments[0].docType"
          (change)="onSupportingDocTypeMobileChanged()"
        >
          <option [ngValue]="null">
            {{ "PICK_AN_OPTION" | globalTranslate }}
          </option>
          @for (option of supportingDocOptions; track option) {
          <option [ngValue]="option">
            {{
              translatedLang === "en"
                ? option.enDescription
                : option.spDescription
            }}
          </option>
          }
        </select>
      </div>
    </div>
    }
    <!-- uploaded Files -->
    <div class="row upload_doc">
      @for (filteredDoc of filteredDocs; track filteredDoc; let i = $index) {
      <div
        [ngClass]="{
          'upload-document-border p-2 mt-2': i !== 0 && filteredDoc.show
        }" class="document-upload"
      >
        @if (filteredDoc.file) {
        <div class="col d-flex align-items-center pt-3 pb-3 ps-2 pe-2">
          @if (filteredDoc.file.type !== 'application/pdf') {
          <div class="preview-container">
            <img
              (click)="
                isSupportingDocFlow
                  ? viewSupportingPdf(i, 'mobileBrowser')
                  : viewPdf(i, 'mobileBrowser')
              "
              [src]="filteredDoc.filePreview"
              alt="File Preview"
              class="preview"
            />
            <div
              class="hover-red"
              [ngClass]="{ 'lang-sp': translatedLang === 'sp' }"
            >
              <a
                id="remove"
                tabindex="0"
                class="btn btn-link hover-red"
                (click)="
                  isSupportingDocFlow
                    ? removeSupportingItemMobile(i, 'filtered')
                    : removeItemMobile(i)
                "
              >
                <span>{{ "Remove" | globalTranslate }}</span>
                <nh-remove-svg></nh-remove-svg>
              </a>
            </div>
          </div>
          } @if (filteredDoc.file.type === 'application/pdf') {
          <div class="preview-container">
            <pdf-viewer
              (click)="
                isSupportingDocFlow
                  ? viewSupportingPdf(i, 'mobileBrowser')
                  : viewPdf(i, 'mobileBrowser')
              "
              [src]="filteredDoc.filePreview"
              [render-text]="true"
              [original-size]="false"
              class="preview"
            ></pdf-viewer>
            <div
              class="hover-red"
              [ngClass]="{ 'lang-sp': translatedLang === 'sp' }"
            >
              <a
                id="remove"
                tabindex="0"
                class="btn btn-link hover-red"
                (click)="
                  isSupportingDocFlow
                    ? removeSupportingItemMobile(i, 'filtered')
                    : removeItemMobile(i)
                "
              >
                <span>{{ "Remove" | globalTranslate }}</span>
                <nh-remove-svg></nh-remove-svg>
              </a>
            </div>
          </div>
          }
        </div>
        }
      </div>
      }
    </div>
    @if (displayLoading) {
    <div class="row uploaded-documentname">
      <div class="col-8">
        <span class="pe-2 file-icon"
          ><img
            alt=""
            aria-hidden="true"
            role="presentation"
            src="../../../../../../assets/images/⚛️ icons-document-attach-outline.svg"
        /></span>
        <span class="file-name" style="max-width: 440px">{{ docName }}</span>
      </div>
      <div class="col-4">
        <div class="option-lables">
          <img
            src="../../../../../../assets/images/⚛️ File_Uploader_Loader.svg"
          />
        </div>
      </div>
    </div>
    } @if (showClose && displayUpload) {
    <a
      role="button"
      tabindex="0"
      (click)="closeMobile()"
      (keydown.enter)="closeMobile(); $event.preventDefault()"
      (keydown.space)="closeMobile(); $event.preventDefault()"
      class="mobile-upload-btn-close"
      ><span class="pe-2">{{ "CLOSE" | globalTranslate }}</span
      ><i class="fa fa-times-circle" aria-hidden="true"></i
    ></a>
    }<br />
    @if (showClose) {
    <div class="pt-3">
      <div class="col-md-12 mt-4">
        <nh-mobile-file-upload
          (passFileData)="
            isSupportingDocFlow
              ? getSupportingFileDetailsMobile(
                  $event,
                  currentSupportingDocIndex
                )
              : getFileDetailsMobile($event, currentI)
          "
          (fileUploadStarted)="getFileProgress($event)"
          [displayLoading]="displayLoading"
        ></nh-mobile-file-upload>
      </div>
    </div>
    }
    <div class="row col-md-12">
      <div class="ms-2">
        <button
          id="addAnother2"
          (click)="addAnotherMobile()"
          class="btn btn-outline-secondary btn-add-another"
          style="
            border-radius: 4px;
            border: 1px solid #132742;
            color: #132742;
            background: #fff;
            text-transform: none;
            font: 700 18px / 27px Open Sans !important;
          "
          [ngClass]="{ 'lang-sp': translatedLang === 'sp' }"
          [hidden]="error"
          [attr.aria-label]="'ADD_PAGE_2' | globalTranslate"
        >
          {{ "ADD_PAGE_2" | globalTranslate }}
          <svg
            id="_icons_add-circle-outline"
            data-name="⚛️ icons/add-circle-outline"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
          >
            <path
              id="Combined_Shape"
              data-name="Combined Shape"
              d="M0,9.75A9.75,9.75,0,1,1,9.75,19.5,9.761,9.761,0,0,1,0,9.75Zm1.5,0A8.25,8.25,0,1,0,9.75,1.5,8.259,8.259,0,0,0,1.5,9.75ZM9,13.514V10.5H6A.75.75,0,0,1,5.985,9H9V6a.75.75,0,0,1,1.5-.015V9h3a.75.75,0,0,1,.014,1.5H10.5v3a.75.75,0,0,1-1.5.014Z"
              transform="translate(2.25 2.25)"
              fill="#174a7c"
            />
          </svg>
        </button>
      </div>
      @if (successDocUpload) {
      <div class="ms-2">
        <button
          [hidden]="error"
          (click)="onContinue()"
          id="continue2"
          class="btn btn-secondary"
        >
          {{ "CONTINUE_1" | globalTranslate }}
        </button>
      </div>
      }
    </div>
    @if (showCZPRmessage) {
    <div style="border: 0px solid #f5e0af; margin-top: 15px">
      {{ "UPLOAD_DOC_TEXT2" | globalTranslate }}
    </div>
    }
  </div>
  }
</div>
